/**
 * IGNIERE §164-9 カートの引き出しを「かぶせる」形にする（2026-08-10・user 裁定）
 *
 * 背景：Horizon は PC（幅 481px 以上）でカートの引き出しを **非モーダル**（`show()`）で開き、
 * 同時に `.page-wrapper--drawer-open { margin-right: 引き出しの幅 }` で**ページ本体を細くする**。
 * 結果、ページが左へ押しのけられ、背後は落ちない（＝裏を触れる設計）。
 * 実測 2026-08-10＝題字の中心 720px → 480px・ページの幅 1440px → 960px。
 *
 * user 裁定（2026-08-10）：**かぶせる方式にする**。
 * 根拠＝user が Shopify 公式のストア紹介から 20〜30 サイトを目視し、引き出し方式を採る店の
 * **100% が「かぶせる」だった**。あわせて、私の 45 サイト調査は掲載日が 2〜3 年前のものを多く含み、
 * 「ページ式が主流」という結論に偏りがあったことも確認された。
 *
 * この JS の役目は 1 つだけ：**膜を出し、押されたら閉じる**。
 * ページを細くしない指定と、膜の見た目（明度 0.75）は CSS 側（igniere-brand-2.liquid §164-9）。
 *
 * Horizon のコアには触れていない（掟 §3 の経路①＝JS runtime）。
 * 非モーダルのままなので、キーボードの閉じ込めは Horizon の `trapFocus` がすでに担っている。
 */
(function () {
  'use strict';

  var ID = 'ig-cart-scrim';
  var MIN_WIDTH = 481; // これ未満は引き出しが全画面＝膜の出番が無い

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  function ensureScrim() {
    var el = document.getElementById(ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = ID;
    el.setAttribute('aria-hidden', 'true'); // 読み上げの木には出さない（見た目だけの膜）
    el.addEventListener('click', function () {
      var d = drawer();
      if (d && typeof d.close === 'function') d.close();
      else if (d) d.removeAttribute('open');
    });
    document.body.appendChild(el);
    return el;
  }

  function sync() {
    var d = drawer();
    if (!d) return;
    var open = d.hasAttribute('open') && window.innerWidth >= MIN_WIDTH;
    var el = ensureScrim();
    el.classList.toggle('is-on', open);
  }


  // ────────────────────────────────────────────────────────────
  // §164-10「買い物を続ける」は閉じるだけにする（user 裁定 2026-08-10）
  // 純正は商品一覧へ遷移する `<a>`。かぶせる方式にした以上、閉じれば元居た面へ戻る＝
  // わざわざ別の面へ飛ばす必要が無い。役割は閉じるボタンと同じ。
  // ────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var a = e.target instanceof Element ? e.target.closest('#cart-drawer .cart-items__empty-button') : null;
    if (!a) return;
    e.preventDefault();
    var d = drawer();
    if (d && typeof d.close === 'function') d.close();
    else if (d) d.removeAttribute('open');
  });

  // ────────────────────────────────────────────────────────────
  // §164-11 送料無料まで あと◯円（user 要望 2026-08-10）
  //
  // ⚠ 閾値は**仮の値**（¥20,000）。告知帯の文言と同じ数字を置いている。
  //    確定したら **4 箇所を同時に直す**（ご利用ガイド／特商法／配送ポリシー／ここ）＋告知帯。
  //    正本＝60_開発/shopify/機能ロードマップ.md §7-A・backlog の「送料無料閾値の確定」
  //
  // 金額の単位：Shopify の /cart.js は **円でも 100 倍**で返す（実測＝¥39,600 → 3960000）。
  // ────────────────────────────────────────────────────────────
  var FREE_SHIPPING_YEN = 20000; // 確定 2026-08-16（台帳 機能ロードマップ §7-A）。変える時は特商法・配送ポリシー・ガイド・PDP サービスパネル・告知帯も同時に

  function yen(n) {
    return '¥' + Math.round(n).toLocaleString('ja-JP');
  }

  /* §256（2026-10-03・監査の引き継ぎ 2 件目）帯は引き出しだけでなく**カートのページ（/cart）の小計の上**にも出す。
     引き出し「送料無料でお届けします」とページ「送料はご購入手続きの画面で計算されます。」が食い違っていた＝同じ帯を
     同じ規則で両方に描き、注記の出し分け（§234）もページ側に広げる。帯は class .ig-ship-bar（引き出しの物は従来の id も持つ） */
  /* §388-2（2026-10-27・代表の実機「通常は、小計、送料があって、その下に『あと◯円で送料無料』って流れ」）
     帯の置き場を小計の上から**送料の行のすぐ下**へ（引き出しもページも小計の箱 .cart-totals の中）。読む順＝小計 → 送料 → あといくらで無料。
     送料の行（renderShipRow）が先に描かれている前提＝refreshShipBar で renderPageExtras を先に呼ぶ */
  function shipHosts() {
    var hosts = [];
    ['#cart-drawer .cart-totals', '#MainContent .cart-summary .cart-totals'].forEach(function (sel) {
      var h = document.querySelector(sel);
      if (h) hosts.push(h);
    });
    return hosts;
  }

  function renderShipBar(cart) {
    shipHosts().forEach(function (host) { renderShipBarIn(host, cart); });
  }

  // §351-5（2026-10-22）ログイン中で残高がある時だけ、購入手続きのボタンのすぐ上に残高の行（商品ページの値段の下と同じ形）
  //   （値は snippets/igniere-brand.liquid が window.IG_CREDIT に渡す・見た目は src/css/40-brand-3b.css の .ig-credit-line）
  var GIFT = '<svg class="ig-credit-line__icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 8.5h15V12h-15z"/><path d="M6 12v8.5h12V12"/><path d="M12 8.5v12"/><path d="M12 8.5C8.5 8.5 7.5 4.5 10 4.2c2-.2 2.4 2.3 2 4.3zM12 8.5c3.5 0 4.5-4 2-4.3-2-.2-2.4 2.3-2 4.3z"/></svg>';
  function renderCreditCard(cart) {
    ['#cart-drawer .cart__ctas', '#MainContent .cart-summary .cart__ctas'].forEach(function (sel) {
      var ctas = document.querySelector(sel);
      if (!ctas) return;
      var line = ctas.previousElementSibling && ctas.previousElementSibling.classList.contains('ig-credit-line') ? ctas.previousElementSibling : null;
      if (!window.IG_CREDIT || cart.item_count === 0) { if (line) line.remove(); return; }
      if (!line) {
        line = document.createElement('p');
        line.className = 'ig-credit-line';
        line.innerHTML = GIFT + '<span class="ig-credit-line__t"><span class="ig-nw">今回のお買い物にご利用いただける</span><wbr><span class="ig-nw"><b></b>のストアクレジットをお持ちです。</span></span>';
        ctas.parentNode.insertBefore(line, ctas);
      }
      var b = line.querySelector('b'), want = window.IG_CREDIT + '円分';
      if (b.textContent !== want) b.textContent = want;
    });
  }

  function renderShipBarIn(host, cart) {
    var el = host.querySelector('.ig-ship-bar');
    if (cart.item_count === 0) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'ig-ship-bar';
      if (host.closest('#cart-drawer')) el.id = 'ig-ship-bar';
      el.innerHTML = '<p class="ig-ship-bar__t"></p><span class="ig-ship-bar__rail"><span class="ig-ship-bar__fill"></span></span>';
    }
    var row = host.querySelector('.ig-ship-row');
    if (row) { if (row.nextSibling !== el) row.parentNode.insertBefore(el, row.nextSibling); }
    else if (el.parentNode !== host) host.appendChild(el);
    var total = cart.total_price / 100;
    var rest = FREE_SHIPPING_YEN - total;
    var t = el.querySelector('.ig-ship-bar__t');
    var fill = el.querySelector('.ig-ship-bar__fill');
    if (rest > 0) {
      // §278（C2）和文と数字の間に空白を入れない（§20.1）
      // §388-2（代表「『￥マーク』ではなく、『円』の方が読みやすいかな（文章なので）」）文の中の金額は「円」。金額だけを示す欄（小計・送料の行）は「¥」のまま
      t.textContent = 'あと' + Math.round(rest).toLocaleString('ja-JP') + '円で送料無料';
      el.classList.remove('is-done');
    } else {
      t.textContent = '送料無料でお届けします';
      el.classList.add('is-done');
    }
    var pct = Math.max(0, Math.min(100, (total / FREE_SHIPPING_YEN) * 100));
    fill.style.width = pct + '%';
  }

  // ────────────────────────────────────────────────────────────
  // §164-14「税込」を金額のすぐ右へ（user 指示 2026-08-10・日本の通販の作法）
  // 純正は注記の文（「税込。ディスカウントと配送料は…」）の中に混ぜていた。
  // 金額の要素は `text-component` というカスタム要素で **擬似要素が描かれない**ため
  // （実測＝content は算出されるのに箱の幅が 0）、本物の span を足す。
  // ────────────────────────────────────────────────────────────
  // §272（監査 027・代表 D4）カートのページ（/cart）の小計にも同じ「（税込）」を付ける（引き出しだけだった）
  function markTaxIncluded() {
    ['#cart-drawer .cart-totals__total', '#MainContent .cart-summary .cart-totals__total'].forEach(function (sel) {
      var box = document.querySelector(sel);
      if (!box || box.querySelector('.ig-tax-note')) return;
      var v = box.querySelector('.cart-totals__total-value');
      if (!v) return;
      var s = document.createElement('span');
      s.className = 'ig-tax-note';
      s.textContent = '（税込）';
      // 行は左右に離す組みなので、**金額の箱の中**へ入れる（隣に置くと右端へ飛ぶ）
      v.appendChild(s);
    });
  }

  // ────────────────────────────────────────────────────────────
  // §272（監査 028・代表 D4「最低限の調整と修正はしたい」）カートのページだけに 2 つ足す。
  // ①小計の下に送料の行（無料／¥660）＝送料は全国一律 660 円・20,000 円以上で無料（ガイド 01 章・配送ポリシー）。
  //   金額が分かるので、純正の注記「送料はご購入手続きの画面で計算されます。」はページでは隠す（CSS）。
  // ②決定ボタンの下に「買い物を続ける」。引き出しは閉じれば元の面に戻るので置かない（§186）が、
  //   カートのページは面ごと移っているので戻り道が要る。
  // ────────────────────────────────────────────────────────────
  // §388（2026-10-27・代表「案Bでお願いします。」）送料の行は引き出しにも出す（ページだけだったので、引き出しは
  //   純正の注記「送料はご購入手続きの画面で計算されます。」のまま＝同じ中身でページと食い違っていた）。
  //   ⚠ 送料の額はテーマに書いた値＝送料を変える時は HANDOFF §C⑥ の一覧どおり、ここも直す（店の配送の設定は読まない＝代表の判断）
  var SHIPPING_YEN = 660;
  function renderShipRow(totals, cart) {
    var row = totals.querySelector('.ig-ship-row');
    if (cart.item_count === 0) { if (row) row.remove(); return; }
    if (!row) {
      row = document.createElement('div');
      row.className = 'ig-ship-row';
      row.innerHTML = '<span class="ig-ship-row__k">送料</span><span class="ig-ship-row__v"></span>';
      var total = totals.querySelector('.cart-totals__total');
      if (total) total.parentNode.insertBefore(row, total.nextSibling); else totals.appendChild(row); // 小計の行のすぐ下（同じ親の中）
    }
    // 「（税込）」は小計と同じ小さな注記（.ig-tax-note）で添える。同じ値を書き戻さない（見張りの輪を作らない）
    var want = cart.total_price / 100 >= FREE_SHIPPING_YEN ? '無料' : yen(SHIPPING_YEN) + '<span class="ig-tax-note">（税込）</span>';
    var v = row.querySelector('.ig-ship-row__v');
    if (v.innerHTML !== want) v.innerHTML = want;
  }
  function renderPageExtras(cart) {
    var dt = document.querySelector('#cart-drawer .cart-totals');
    if (dt) renderShipRow(dt, cart);
    var totals = document.querySelector('#MainContent .cart-summary .cart-totals');
    if (!totals) return;
    renderShipRow(totals, cart);
    var keep = document.querySelector('#MainContent .cart-summary .ig-keep-shopping--page');
    if (cart.item_count === 0) { if (keep) keep.remove(); return; }
    if (!keep) {
      var summary = document.querySelector('#MainContent .cart-summary .cart-summary__inner') || document.querySelector('#MainContent .cart-summary');
      keep = document.createElement('a');
      keep.className = 'ig-keep-shopping--page';
      keep.href = '/collections/all';
      keep.textContent = 'お買い物を続ける';
      summary.appendChild(keep);
    }
  }

  // ────────────────────────────────────────────────────────────
  // §164-16「買い物を続ける」を商品が入っている時にも置く（user 指摘 2026-08-10）
  // 純正はカートが空の時だけ出す。中身がある時こそ「まだ見る」人がいるので、
  // 決定ボタンの下に静かに置く。役目は閉じるボタンと同じ（§164-10 と同じ考え）。
  // ────────────────────────────────────────────────────────────
  // §186（2026-08-15 user 裁定）「買い物を続ける」は置かない＝§164-15/-16 の**撤回**。
  // かぶせる方式では、閉じれば元居た面に戻る。同じ役目のものが 2 つ（閉じるボタンと本ボタン）
  // 並んでいて、決定ボタン 1 つに黒を集めるという面の設計を薄めていた。
  // 既に挿入済みの分も取り除く（開きっぱなしのページで残らないように）。
  // ────────────────────────────────────────────────────────────
  // §278（K4・C1）明細の見出しを日本語の書き方に（ページと引き出しの両方）
  //   色・サイズ：純正は見出し（オプション名「COLOR:」）を読み上げ専用で隠し、値だけ出す＝「ブラス」だけでは何の情報か分からない（監査014）
  //     → 見出しを見せ、日本語に（カラー：ブラス）。知らないオプション名はそのまま見せる
  //   発送などの属性：「発送: メーカー直送…」の半角コロン＋空白 → 「発送：」（和文の書き方）
  //   書き換えるのは違う時だけ（同じ値を書き戻すと見張りが反応して輪になる）
  // ────────────────────────────────────────────────────────────
  var OPTION_JA = { COLOR: 'カラー', COLOUR: 'カラー', SIZE: 'サイズ', '色': 'カラー', 'カラー': 'カラー', 'サイズ': 'サイズ' };
  // 見出し（dt）と値（dd）の間の改行は、横並びの時に半角の空白として描かれる（「カラー： ブラス」）＝空白だけの文字の節を外す
  function dropGap(dt) {
    var n = dt.nextSibling;
    if (n && n.nodeType === 3 && !n.textContent.trim()) n.remove();
  }
  function relabelLines() {
    document.querySelectorAll('#cart-drawer .cart-items__variant dt, #MainContent .cart-page .cart-items__variant dt').forEach(function (dt) {
      var raw = dt.textContent.replace(/[:：]\s*$/, '').trim();
      var ja = OPTION_JA[raw.toUpperCase()] || OPTION_JA[raw] || raw;
      var want = ja + '：';
      if (dt.textContent !== want) dt.textContent = want;
      if (dt.classList.contains('visually-hidden')) dt.classList.remove('visually-hidden');
      dropGap(dt);
      // 純正は値の末尾に「,&nbsp;」を足して色とサイズをつなぐ＝外し、区切りは CSS の「／」に任せる（カラー：ナチュラル／サイズ：M）
      var dd = dt.nextElementSibling;
      if (dd && /,\s*$/.test(dd.textContent)) dd.textContent = dd.textContent.replace(/,\s*$/, '');
    });
    document.querySelectorAll('#cart-drawer .cart-items__property dt, #MainContent .cart-page .cart-items__property dt').forEach(function (dt) {
      var want = dt.textContent.replace(/\s*:\s*$/, '：');
      if (dt.textContent !== want) dt.textContent = want;
      dropGap(dt);
    });
  }

  /* §404（2026-11-02）カートのドロワーをお気に入りのドロワーの作りに揃える（代表「案Aでモックでお願いします。」）
     Horizon のカートはドロワーで販売元を出す設定を持たない（block_settings.vendor はページの block だけ）＝コアを触らずここで足す。 */
  function brandLabel(item) {
    var v = String(item.vendor || '').trim();
    if (v && v.toUpperCase() !== 'NO BRAND') return v;
    return item.product_type || ''; // 商品カードと同じ（blocks/_igniere-card-category.liquid・§270）
  }
  var lastCart = null;
  function renderBrands(cart) {
    lastCart = cart;
    var byKey = {};
    (cart.items || []).forEach(function (i) { byKey[i.key] = i; });
    document.querySelectorAll('#cart-drawer tbody tr[data-key], #MainContent .cart-page tbody tr[data-key]').forEach(function (row) {
      var item = byKey[row.getAttribute('data-key')];
      var info = row.querySelector('.cart-items__product-info');
      if (!item || !info) return;
      var label = brandLabel(item);
      var el = info.querySelector('.ig-cart-brand');
      if (!label) { if (el) el.remove(); info.classList.add('ig-has-brand'); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'ig-cart-brand';
        info.insertBefore(el, info.firstChild);
      }
      if (el.textContent !== label) el.textContent = label;
      info.classList.add('ig-has-brand');
    });
  }
  function wishlistConfig() {
    try { return JSON.parse(document.getElementById('ig-wishlist-config').textContent); } catch (e) { return {}; }
  }
  // ログインの帯＝お気に入りのドロワーと同じ部品。ゲストの時だけ、ヘッダーの直下に 1 行
  function renderLoginBand() {
    var d = drawer();
    var header = d && d.querySelector('.theme-drawer__header');
    if (!header) return;
    var cfg = wishlistConfig();
    var old = d.querySelector('.ig-wl-login');
    if (!cfg.guest || !cfg.loginUrl) { if (old) old.remove(); return; }
    if (old && old.previousElementSibling === header) return;
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'ig-wl-login';
    p.appendChild(document.createTextNode('ログインすると、購入手続きがスムーズに行えます'));
    var a = document.createElement('a');
    a.className = 'ig-wl-login__link';
    a.href = cfg.loginUrl;
    a.textContent = 'ログイン';
    p.appendChild(a);
    header.insertAdjacentElement('afterend', p);
  }
  // 空の時だけ、お気に入りのドロワーと同じ CHECKED ITEMS（assets/igniere-wishlist.js の igCheckedShelf）
  function renderEmptyShelf() {
    var d = drawer();
    var empty = d && d.querySelector('[data-cart-drawer-empty]');
    var host = empty && empty.closest('.cart-drawer__content');
    if (host && window.igCheckedShelf) window.igCheckedShelf(host);
  }

  // §405 Horizon が中身を差し替えると、足した物（ブランド名・帯・棚）が一緒に消える。/cart.js の返事を待って入れ直すと、
  // その間だけ直す前の見た目が出る（削除の時に 7 フレーム）＝見張りの中で描かれる前に戻す。ブランド名は前の返事の控えを使う
  function syncOwn() {
    if (lastCart) renderBrands(lastCart);
    renderLoginBand();
    renderEmptyShelf();
  }

  function removeKeepShopping() {
    var el = document.querySelector('#cart-drawer .ig-keep-shopping');
    if (el) el.remove();
  }

  var shipTimer = null;
  function refreshShipBar() {
    if (shipTimer) clearTimeout(shipTimer);
    // 数量の増減は少し遅れて反映されるので、まとめて 1 回だけ取りに行く
    shipTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) { renderPageExtras(c); renderShipBar(c); renderCreditCard(c); renderBrands(c); } markTaxIncluded(); removeKeepShopping(); relabelLines(); renderLoginBand(); renderEmptyShelf(); })
        .catch(function () { /* 取れなくても買い物は止めない */ });
    }, 220);
  }

  // ────────────────────────────────────────────────────────────
  // §186-2（2026-08-15 user 実機指摘「Close に枠線がつく」）
  // 真因＝Horizon コア（theme-drawer.js 285 行 `closeButton?.focus()`）が、開いた瞬間に
  // **操作要素である閉じるボタンへプログラムでフォーカスを当てている**。
  // Chromium では :focus-visible にならないが、**Safari はプログラムのフォーカスでも
  // :focus-visible と判定する**ため、iPhone では指で開いただけで輪郭が出る。
  // （ヘッドレスでは再現しない類＝§21.3「ヘッドレスを実機の証明にしない」）
  //
  // 直し方＝**輪郭を消すのではなく、フォーカスの当て先を器へ移す**。
  // 輪郭は §7.1 のアクセシビリティの床なので消してはいけない。
  // §16.24-6（v0.7.32 批准）も「開いたら器へ」と定めており、カートだけ古い作法が残っていた。
  // 器（パネル）は操作要素ではないので輪郭を出さない（CSS 側で outline: none）。
  // キーボードで Tab を押せば閉じるボタンに輪郭が出る＝床は保たれる。
  // Horizon コアは編集しない（掟 §3・経路①＝JS runtime で上書き）。
  // ────────────────────────────────────────────────────────────
  function retargetInitialFocus() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(function () {
      if (!d.hasAttribute('open')) return;
      // ⚠ 器は `.theme-drawer__dialog`（<dialog ref="panel">）。
      //    コア内部の呼び名 refs.panel をクラス名だと思い込むと空振りする（実測 2026-08-15）
      var panel = d.querySelector('.theme-drawer__dialog');
      var close = d.querySelector('.theme-drawer__close-button');
      if (!panel) return;
      // コア側の focus() より後に走るよう 1 フレーム待つ
      requestAnimationFrame(function () {
        if (document.activeElement !== close) return;   // 人が自分で合わせた時は触らない
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: true });
      });
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  /* 帯そのものの描き換え（文言・幅）で見張りが反応して /cart.js を取り直す輪を作らない */
  function refreshUnlessOwn(records) {
    syncOwn();
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (!(t instanceof Element)) t = t.parentElement;
      if (t && t.closest && t.closest('.ig-ship-bar, .ig-ship-row, .ig-wl-checked')) continue;
      // §404 自分で入れたブランド名・帯・棚だけの変化では取り直さない（輪にしない）
      var nodes = Array.prototype.slice.call(records[i].addedNodes).concat(Array.prototype.slice.call(records[i].removedNodes));
      if (nodes.length && nodes.every(function (n) { return n.nodeType === 1 && n.matches('.ig-cart-brand, .ig-wl-login, .ig-wl-checked'); })) continue;
      refreshShipBar();
      return;
    }
  }

  function start() {
    var d = drawer();
    var pageSummary = document.querySelector('#MainContent .cart-summary');
    if (d) {
      // 引き出しの open 属性を見張る（Horizon 側の開閉に追従する・こちらからは開けない）
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
      window.addEventListener('resize', sync);
      sync();
      // 引き出しの中身が入れ替わったら送料の帯を出し直す（数量の増減・削除・追加）
      new MutationObserver(refreshUnlessOwn).observe(d, { childList: true, subtree: true });
    }
    if (pageSummary && !pageSummary.dataset.igShipWatch) {
      // §256 カートのページ：小計の面が差し替わったら（数量の増減・削除）帯を出し直す
      pageSummary.dataset.igShipWatch = '1';
      var scope = pageSummary.closest('.shopify-section') || pageSummary;
      new MutationObserver(refreshUnlessOwn).observe(scope, { childList: true, subtree: true });
    }
    if (!d && !pageSummary) return;
    refreshShipBar();
    markTaxIncluded();
    removeKeepShopping();
    relabelLines();
    renderLoginBand();
    renderEmptyShelf();
    if (d) retargetInitialFocus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // ページの一部が差し替わって引き出しが作り直された時に見張り直す
  document.addEventListener('shopify:section:load', start);
})();
